







































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import * as def from '@/definitions'
// TODO document2
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { SVGPathData, SVGPathDataTransformer, SVGPathDataParser } from 'svg-pathdata';
import { BarcodeLayer } from '@/model/document2/page/surface/design/layer/barcodeLayer';
import { CodeHelper } from '@/helper/codeHelper';
import { UnitHelper } from '@/helper/unitHelper';
import { DebugHelper } from '@/helper/debugHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';

import { Rectangle } from '@/utilityModels/rectangle';
import { FontManager } from '@/model/fontManager/fontManager';

import { Const } from '@/const';

@Component({
    components: {
    },
})
export default class BarcodeLayerDrawer extends Vue 
{
    private static readonly ERROR_MESSAGE = "表示できません\nサイズや文字をご確認ください";
    private static readonly ERROR_MESSAGE_COLOR = "#4A4A4A";
    private static readonly ERROR_MESSAGE_FONT_ID = "noto-sans-jp-400";

    private get numberFont() { return Const.FONT_FAMILY_OCRB; }

    // 最小フォントサイズ(pt)
    static readonly MIN_FONT_SIZE = 1;
    static readonly MAX_FONT_SIZE = 720;

    // 幅に対する数字の高さの割合
    private getNumberHeightRatio()
    {
        var ratio = 0.1;
        if(this.layer.barcodeType == 9) { ratio = 0.075; }           // GS1(標準)
        else if(this.layer.barcodeType == 10) { ratio = 0.045; }     // GS1(拡張)
        else if(this.layer.barcodeType == 12) { ratio = 0.03; }     // GS1-128
        return ratio;
    }

    private isGS1Barcode() { return CodeHelper.isGS1Barcode(this.layer.barcodeType); }

    @Prop() private layer!: BarcodeLayer;
    @Prop() private scale!: number;
    @Prop() private offsetX!: number;
    @Prop() private offsetY!: number;
    @Prop() private isRendering!: boolean;

    private imageSource = "";

    @Watch("layer.barcodeType")
    barcodeTypeChanged() { this.updateBarcode(); }

    @Watch("layer.text")
    textChanged() { this.updateBarcode(); }

    @Watch("layer.showNumber")
    showNumberChanged() { this.updateBarcode(); }

    @Watch("layer.width")
    widthChanged() { this.updateBarcode(); }

    @Watch("layer.height")
    heightChanged() { this.updateBarcode(); }

    // 数値の描画位置(GS1)
    private numberDrawX : number = 0;
    private numberDrawY : number = 0;
    // 数値の描画位置更新
    private updateNumberDrawPosition()
    {
        if(this.isGS1Barcode())
        {
            // 更新はGS1のみ
            var fontSize = this.layer.width * this.getNumberHeightRatio();
            var width = Const.FONT_WIDTH_RATION_OCRB * fontSize * this.layer.text.length;
            this.numberDrawX = (this.layer.width - width) / 2;
            this.numberDrawY = this.layer.height;
        }
    }

    // エラーメッセージを表示していいか
    private get isErrorMessageVisible()
    {
        // レンダリングでは出さない
        if(this.isRendering) { return false; }
        // レイアウト、印刷プレビューでは出さない
        var path = this.$router.currentRoute.path;
        if(path == "/PrintSetting" || path == "/LayoutEditor") { return false; }
        return true;
    }

    // マウント済みフラグ
    private ismounted = false;
    mounted() 
    { 
        this.updateDefs();
        this.ismounted = true;
        this.updateBarcode();
        // 呼び出しを遅延しないとバーコードサイズの計算がおかしくなることがある
        setTimeout(() => this.updateImageSource(), 10);
    }

    barcodeImage = "";

    private updateBarcode()
    {
        this.updateNumberDrawPosition();
        this.updateImageSource();
    }

    private updateDefs()
    {
        var xmlDoc = new DOMParser().parseFromString('<xml></xml>', 'application/xml');
        var defsId = 'barcode_layer_drawer_defs_' + this.layer.id;
        var defs = document.getElementById(defsId);
        if (defs == null) return;
        if (defs.hasChildNodes()) return;
        // defsにCDATAとしてstyleSheetを追加する。
        // styleSheetにはwoffファイルをbase64変換したものを設定し、font-family="ocrBarcode"として定義する。
        var cdataStr = CodeHelper.getOcrFontFace();
        var cdata = xmlDoc.createCDATASection(cdataStr);
        var style = xmlDoc.createElementNS("http://www.w3.org/2000/svg", "style");
        style.type = "text/css";
        style.appendChild(cdata);
        defs.appendChild(style);
    }

    private updateImageSource()
    {
        this.imageSource = CodeHelper.createBarcode(this.layer.barcodeType, this.layer.text, this.layer.showNumber, this.layer.width, this.layer.height);
    }

    // エラーメッセージ

    // エラーメッセージの各行設定のメイン処理
    private getErrorMessageLines(fontSize : number)
    {
        // フォントスタイル
        var fontSizePx = UnitHelper.convert(fontSize, "pt", "px");
        var style = {
            "font-size" : fontSizePx,
            "font-style" : "bold",
            "fill" : BarcodeLayerDrawer.ERROR_MESSAGE_COLOR
        };
        var fontManager : FontManager = this.$store.getters.fontManager;
        var fontFamily = fontManager.getFontFamilyName(BarcodeLayerDrawer.ERROR_MESSAGE_FONT_ID, false, this.isRendering, false)

        var array = new Array();
        var lines = BarcodeLayerDrawer.ERROR_MESSAGE.split(/\r?\n/g);
        var y = 0;
        for(var i = 0; i < lines.length; ++i)
        {
            var line = lines[i];
            // サイズ計測
            var size = StringHelper.calcTextSizeOnSVGPt(line, fontSizePx / 10, fontFamily);
            size.width *= 10;
            size.height *= 10;
            y += size.height;
            array.push({
                text : line,
                x : 0,
                y : y,
                style : style,
                fontFamily : fontFamily,
                width : size.width,
                height : size.height
            });
        }
        return array;
    }

    private get errorMessageLines()
    {
        var array = new Array();
        // マウント前はテキストサイズが計算できないので空を返す
        if(!this.ismounted) { return new Array(); }

        // サイズを確定する
        var tryFontSize = 1;
        var tryBeforeFontSize = 1;
        var step = 20;
        while(true)
        {
            // 仮に配置してみる
            array = this.getErrorMessageLines(tryFontSize);
            // 文字群の幅・高さを求める
            var minX = 0;
            var minY = 0;
            var maxX = 0;
            var maxY = 0;
            for(var i = 0; i < array.length; ++i)
            {
                var info = array[i];
                if(i == 0 || info.x < minX) { minX = info.x; }
                if(i == 0 || info.y < minY) { minY = info.y; }
                if(i == 0 || info.x + info.width > maxX) { maxX = info.x + info.width; }
                if(i == 0 || info.y + info.height > maxY) { maxY = info.y + info.height; }
            }
            var totalWidth = maxX - minX;
            var totalHeight = maxY - minY;

            if(totalWidth > this.layer.width * this.scale || totalHeight > this.layer.height * this.scale)
            {
                // レイヤー領域を超えてしまったので、フォントサイズを再設定する
                if(step == 20) { step = 10; }
                else if(step == 10) { step = 5; }
                else if(step == 5) { step = 2; }
                else if(step == 2) { step = 1; }
                else if(step == 1) { step = 0.3; }
                else if(step == 0.3) { step = 0.1; }
                else 
                {
                    // 以前のサイズで決定する
                    break;
                }

                // 以前のサイズにstepを加えて再チャレンジする
                tryFontSize = tryBeforeFontSize + step;
            }
            else
            {
                // レイヤー領域を超えない。stepを加えてもう一度計測する
                tryBeforeFontSize = tryFontSize;
                tryFontSize += step;
            }
            
            if(tryFontSize <= 0)
            {
                tryFontSize = BarcodeLayerDrawer.MIN_FONT_SIZE;
                break;
            }

            if(tryFontSize >= BarcodeLayerDrawer.MAX_FONT_SIZE)
            {
                tryFontSize = BarcodeLayerDrawer.MAX_FONT_SIZE;
                tryBeforeFontSize = tryFontSize;
                break;
            }

            // フォントサイズ決定
            array = this.getErrorMessageLines(tryBeforeFontSize);
        }

        return array;
    }

    private get width()
    {
        return this.layer.width;
    }

    private get height()
    {
        return this.layer.height;
    }

    private get imageX()
    {
        return (this.layer.width - this.imageWidth) / 2;
    }

    private get imageY()
    {
        if((this.isGS1Barcode()) && this.layer.showNumber)
        {
            // GS1対応
            return 0;
        }
        return (this.layer.height - this.imageHeight) / 2;
    }

    private get imageWidth()
    {
        return this.layer.width * this.getFixScale('x');
    }
    
    private get imageHeight()
    {
        return this.layer.height * this.getFixScale('y');
    }

    private getFixScale(type = '')
    {
        if(this.layer.barcodeType == 2 || this.layer.barcodeType == 3 || this.layer.barcodeType == 4)
        {
            // 物流コード対応
            // ベアラバーの表示エリアを確保するために縮小する
            // スケール
            var fixScale = 1 - (4.83 + 10.16) * 2 / 152.4;
            return fixScale;
        }
        else if(type == 'y' && this.isGS1Barcode() && this.layer.showNumber)
        {
            // GS1対応
            // テキスト表示エリアのために縮小する
            var textHeight = this.layer.width * this.getNumberHeightRatio();
            return this.layer.height != 0 ? (this.layer.height - textHeight) / this.layer.height : 1.0;
        }
        else
        {
            return 1.0;
        }
    }

    private get numberstyle()
    {
        var style = {
            "font-size" : (this.layer.width * this.getNumberHeightRatio()),
            "fill" : '#000000',
            "text-align" : 'center'
        };
        return style; 
    }

    private get transform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + "),";

        // スケーリング
        transform += "scale(" + this.scale + ")";
        
        return transform;
    }

    private get textTransform() : string
    {
        var transform = "";

        // オフセット
        var offsetX = this.offsetX + this.layer.x * this.scale;
        var offsetY = this.offsetY + this.layer.y * this.scale;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // 回転を適用する
        transform += "rotate(" + this.layer.rotate + ")";
        
        return transform;
    }

    // ベアラバー
    private get isVisibleBearerBar()
    {
        if(this.imageSource == "") { return false; }
        return this.layer.barcodeType == 2 || this.layer.barcodeType == 3 || this.layer.barcodeType == 4;
    }

    private get bearerBarRect() 
    {
        var size = CodeHelper.calcBarcodeSize(this.layer.barcodeType, this.layer.text, this.layer.showNumber, this.layer.width, this.layer.height);
        var scale = this.layer.width / size.width * this.getFixScale();
        var barHeight = size.height * scale;
        var w = this.layer.width;
        var h = barHeight;
        var x = (this.layer.width - w) / 2;
        var y = (this.layer.height - h) / 2;
        if(this.layer.showNumber)
        {
            var sizeNoNumber = CodeHelper.calcBarcodeSize(this.layer.barcodeType, this.layer.text, false, this.layer.width, this.layer.height);
            barHeight = sizeNoNumber.height * scale;
            y = (this.layer.height - barHeight) / 2;
        }        

        return new Rectangle(x, y, w, h);
    }

    private get bearerBarThickness() { return this.layer.width * 4.83 / 152.4; }
}
